<template>
	<component :is="tag" class="@container">
		<div
			class="grid gap-px overflow-clip rounded-2xl border border-gray-300 bg-gray-300 dark:border-gray-600 dark:bg-gray-600"
			:class="{ '@2xl:grid-cols-7 @4xl:grid-cols-2': isAgent && showDeepLinks }"
		>
			<BaseButton
				color="lightGray"
				:rounded="false"
				class="!h-full !justify-start truncate"
				:class="{ '@2xl:col-span-4 @4xl:col-span-1': isAgent && showDeepLinks }"
				@click.stop="handleClick()"
			>
				<template #prepend>
					<SFProfileImage width="48" :associate_id="associate_id" />
				</template>
				<div class="grid truncate text-left">
					<span class="font-semibold">
						{{ title }}
					</span>
					<span class="text-xs opacity-60">
						{{ subtext }}
					</span>
				</div>
			</BaseButton>
			<div
				v-if="showDeepLinks && isAgent"
				class="@container/deep-links @2xl:col-span-3 @4xl:col-span-1"
			>
				<div
					class="grid h-full gap-px @[17rem]/deep-links:grid-cols-2 @md/deep-links:grid-cols-4"
				>
					<BaseButton
						v-for="(action, i) in actions"
						:key="i"
						color="lightGray"
						:rounded="false"
						dense
						class="!h-full"
						@click.stop="
							handleClick({
								name: action.name,
								params: { agentID: muid ? muid : associate_id },
							})
						"
					>
						<FAIcon :icon="action.icon" class="mr-1" />
						<span>{{ action.label }}</span>
					</BaseButton>
				</div>
			</div>
		</div>
	</component>
</template>
<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useSearchHistory } from '@/composables/useSearchHistory';

import BaseButton from '@/components/ui/BaseButton.vue';
import SFProfileImage from '@/components/common/SFProfileImage.vue';

const emit = defineEmits(['choose']);
const props = defineProps({
	title: { type: String, required: true },
	subtext: { type: [String, null], required: true },
	// eslint-disable-next-line vue/prop-name-casing
	associate_id: { type: String, required: true },
	muid: { type: String, required: true },
	link: { type: String, required: true },
	showDeepLinks: { type: Boolean, default: false },
	shouldEmit: { type: Boolean, default: false },
	tag: { type: String, default: 'div' },
});

const router = useRouter();
const { updateSearchHistory } = useSearchHistory();

const isAgent = computed(() => props.title.toLowerCase().startsWith('agent'));
const actions = [
	{ name: 'domains', icon: 'earth-americas', label: 'Domains' },
	{ name: 'emails', icon: 'envelope', label: 'Emails' },
	{ name: 'payment', icon: 'credit-card', label: 'Payment' },
	{ name: 'billing', icon: 'money-bill', label: 'Billing' },
];

async function handleClick(destination) {
	const item = {
		title: props.title,
		subtext: props.subtext,
		associate_id: props.associate_id,
		muid: props.muid,
		link: props.link,
	};

	await updateSearchHistory(item);
	if (props.shouldEmit) {
		emit('choose', item);
	} else {
		router.push(destination || props.link);
	}
}
</script>
